// extracted by mini-css-extract-plugin
module.exports = {"sprite":"Sprite_sprite__2NRZ1","spriteSelected":"Sprite_spriteSelected__1703B","spriteRow":"Sprite_spriteRow__3VFP1"};